export default "__VITE_ASSET__DIgEnJho__"